//BootstrapStarterHeaderUtilities.jsx

export const getWriterMode = (writerMode) => {
    switch (writerMode) {
        case 'Doc':
            return 'view-doc';
        case 'Note Pad':
            return 'view-pad';
        case 'Sticky Note':
            return 'view-sticky';
        default:
            return 'view-sheet';  // Default to Sheet view if no match
    }
};

export const getColorMode = (colorMode) => {
    switch (colorMode) {
        case 'Neutral':
            return 'view-neutral';
        case 'Dark':
            return 'view-dark';
        default:
            return 'view-light';  // Default to Light view if no match
    }
};

export const hideCardMenus = () => {
    const cardOptions = document.getElementById('cardOptions');
    const tagApplier = document.getElementById('tagApplier');

    if (cardOptions && !cardOptions.classList.contains('d-none')) {
        cardOptions.classList.add('d-none');
        console.log('hideCardMenus: Hiding #cardOptions');
    }

    if (tagApplier && !tagApplier.classList.contains('d-none')) {
        tagApplier.classList.add('d-none');
        console.log('hideCardMenus: Hiding #tagApplier');
    }
};
